module.exports = "/img/_/_/_/assets/images/creeper/book/common//35.jpg?eff1ad8460e48876bfefcc82da102722";